{
  "HELP_CENTER": {
    "TITLE": "Centro de ayuda",
    "NEW_PAGE": {
      "DESCRIPTION": "Crea portales de autoservicio para el centro de ayuda de tus clientes. Ayúdales a encontrar respuestas rápidamente, sin esperas. Agiliza las consultas, aumenta la eficiencia de los agentes y mejora la atención al cliente.",
      "CREATE_PORTAL_BUTTON": "Crear Portal"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Sin título"
    },
    "HEADER": {
      "FILTER": "Filtrar por",
      "SORT": "Ordenar por",
      "LOCALE": "Idioma",
      "SETTINGS_BUTTON": "Ajustes",
      "NEW_BUTTON": "Nuevo artículo",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Publicado",
        "DRAFT": "Borrador",
        "ARCHIVED": "Archivado"
      },
      "TITLES": {
        "ALL_ARTICLES": "Todos los artículos",
        "MINE": "Mis artículos",
        "DRAFT": "Artículos borradores",
        "ARCHIVED": "Artículos archivados"
      },
      "LOCALE_SELECT": {
        "TITLE": "Seleccionar idioma",
        "PLACEHOLDER": "Seleccionar idioma",
        "NO_RESULT": "No se encontró el idioma",
        "SEARCH_PLACEHOLDER": "Buscar idioma"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Todos los artículos",
      "PUBLISH_BUTTON": "Publicar",
      "MOVE_TO_ARCHIVE_BUTTON": "Mover a archivado",
      "PREVIEW": "Previsualizar",
      "ADD_TRANSLATION": "Añadir traducción",
      "OPEN_SIDEBAR": "Abrir barra lateral",
      "CLOSE_SIDEBAR": "Cerrar barra lateral",
      "SAVING": "Guardando...",
      "SAVED": "Guardado"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Subir imagen",
        "UPLOADING": "Subiendo...",
        "SUCCESS": "Imagen subida con éxito",
        "ERROR": "Error al subir la imagen",
        "UN_AUTHORIZED_ERROR": "No tienes autorización para subir imágenes",
        "ERROR_FILE_SIZE": "El tamaño de la imagen debe ser menor que {size}MB",
        "ERROR_FILE_FORMAT": "El formato de la imagen debe ser jpg, jpeg o png",
        "ERROR_FILE_DIMENSIONS": "Las dimensiones de la imagen deben ser menores de 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Insertar ancla",
        "TITLE": "Insertar ancla",
        "SUBMIT": "Insertar",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Ajustes del artículo",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Categoría",
          "TITLE": "Seleccionar categoría",
          "PLACEHOLDER": "Seleccionar categoría",
          "NO_RESULT": "No se encontraron categorías",
          "SEARCH_PLACEHOLDER": "Buscar categoría"
        },
        "AUTHOR": {
          "LABEL": "Autor",
          "TITLE": "Seleccionar autor",
          "PLACEHOLDER": "Seleccionar autor",
          "NO_RESULT": "No se encontraron autores",
          "SEARCH_PLACEHOLDER": "Buscar autor"
        },
        "META_TITLE": {
          "LABEL": "Título Meta",
          "PLACEHOLDER": "Agregar un meta título"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta-descripción",
          "PLACEHOLDER": "Añada su meta descripción para mejores resultados SEO..."
        },
        "META_TAGS": {
          "LABEL": "Meta etiquetas",
          "PLACEHOLDER": "Añadir meta-etiquetas separadas por coma..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Archivar artículo",
        "DELETE": "Eliminar artículo"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Sin categoría",
      "SEARCH_RESULTS": "Resultados de la búsqueda para {query}",
      "EMPTY_TEXT": "Buscar artículos para insertar en las respuestas.",
      "SEARCH_LOADER": "Buscando...",
      "INSERT_ARTICLE": "Insertar",
      "NO_RESULT": "No se encontraron artículos",
      "COPY_LINK": "Copiar enlace del artículo al portapapeles",
      "OPEN_LINK": "Abrir artículo en nueva pestaña",
      "PREVIEW_LINK": "Previsualizar artículo"
    },
    "PORTAL": {
      "HEADER": "Portales",
      "DEFAULT": "Predeterminado",
      "NEW_BUTTON": "Portal Nuevo",
      "ACTIVE_BADGE": "activo",
      "CHOOSE_LOCALE_LABEL": "Elige un idioma",
      "LOADING_MESSAGE": "Cargando portales...",
      "ARTICLES_LABEL": "artículos",
      "NO_PORTALS_MESSAGE": "No hay portales disponibles",
      "ADD_NEW_LOCALE": "Añadir un nuevo idioma",
      "POPOVER": {
        "TITLE": "Portales",
        "PORTAL_SETTINGS": "Ajustes del portal",
        "SUBTITLE": "Usted tiene varios portales y puede tener diferentes idiomas para cada portal.",
        "CANCEL_BUTTON_LABEL": "Cancelar",
        "CHOOSE_LOCALE_BUTTON": "Elige un idioma"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "artículos",
            "ADD": "Añadir idioma",
            "VISIT": "Visitar sitio",
            "SETTINGS": "Ajustes",
            "DELETE": "Eliminar"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Configuraciones del portal",
            "ITEMS": {
              "NAME": "Nombre",
              "DOMAIN": "Dominio personalizado",
              "SLUG": "Slug",
              "TITLE": "Título del portal",
              "THEME": "Color del tema",
              "SUB_TEXT": "Subtexto del portal"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Idiomas disponibles",
            "TABLE": {
              "NAME": "Nombre del idioma",
              "CODE": "Código del idioma",
              "ARTICLE_COUNT": "Nº de artículos",
              "CATEGORIES": "Nº de categorías",
              "SWAP": "Intercambiar",
              "DELETE": "Eliminar",
              "DEFAULT_LOCALE": "Predeterminado"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Eliminar portal",
          "MESSAGE": "Está seguro que desea eliminar este portal",
          "YES": "Sí, eliminar portal",
          "NO": "No, mantener portal",
          "API": {
            "DELETE_SUCCESS": "Portal eliminado correctamente",
            "DELETE_ERROR": "Error al eliminar el portal"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Editar portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Información básica"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Personalización del portal"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Categorías"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Idiomas"
          }
        },
        "CATEGORIES": {
          "TITLE": "Categorías en",
          "NEW_CATEGORY": "Nueva categoría",
          "TABLE": {
            "NAME": "Nombre",
            "DESCRIPTION": "Descripción",
            "LOCALE": "Idioma",
            "ARTICLE_COUNT": "Nº de artículos",
            "ACTION_BUTTON": {
              "EDIT": "Editar categoría",
              "DELETE": "Eliminar categoría"
            },
            "EMPTY_TEXT": "No se encontraron categorías"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Actualizar ajustes básicos"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Información del Centro de Ayuda",
            "BODY": "Información básica sobre el portal"
          },
          "CUSTOMIZATION": {
            "TITLE": "Personalización del Centro de Ayuda",
            "BODY": "Personalizar portal"
          },
          "FINISH": {
            "TITLE": "Voila! 🎉",
            "BODY": "¡Ya estás listo!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Atrás",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Crear Portal",
            "TITLE": "Información del Centro de Ayuda",
            "CREATE_BASIC_SETTING_BUTTON": "Crear configuración básica del portal"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Personalización del portal",
            "TITLE": "Personalización del Centro de Ayuda",
            "UPDATE_PORTAL_BUTTON": "Actualizar configuración del portal"
          },
          "FINISH_PAGE": {
            "TITLE": "¡Voila!🎉 ¡Ya estás listo!",
            "MESSAGE": "Ahora puede ver este portal creado en su página de todos los portales.",
            "FINISH": "Ir a la página de todos los portales"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Subir logo",
          "HELP_TEXT": "Este logo se mostrará en el encabezado del portal.",
          "IMAGE_UPLOAD_SUCCESS": "Logo subido correctamente",
          "IMAGE_UPLOAD_ERROR": "Logo eliminado correctamente",
          "IMAGE_DELETE_ERROR": "Error al eliminar el logo"
        },
        "NAME": {
          "LABEL": "Nombre",
          "PLACEHOLDER": "Nombre del portal",
          "HELP_TEXT": "El nombre se utilizará internamente en el portal orientado al público.",
          "ERROR": "El nombre es requerido"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug de portal para urls",
          "ERROR": "Slug es requerido"
        },
        "DOMAIN": {
          "LABEL": "Dominio personalizado",
          "PLACEHOLDER": "Dominio personalizado del portal",
          "HELP_TEXT": "Añádelo solo si quieres usar un dominio personalizado para tus portales. Ej.: {exampleURL}",
          "ERROR": "Introduzca una URL de dominio válida"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Enlace de página principal",
          "PLACEHOLDER": "Enlace de página de inicio del portal",
          "HELP_TEXT": "El enlace utilizado para volver del portal a la página de inicio. Ej.: {exampleURL}",
          "ERROR": "Introduzca una URL de página de inicio válida"
        },
        "THEME_COLOR": {
          "LABEL": "Color del tema del portal",
          "HELP_TEXT": "Este color se mostrará como el color del tema para el portal."
        },
        "PAGE_TITLE": {
          "LABEL": "Título de página",
          "PLACEHOLDER": "Título de página del portal",
          "HELP_TEXT": "El título de la página se utilizará en el portal público.",
          "ERROR": "Título de página requerido"
        },
        "HEADER_TEXT": {
          "LABEL": "Texto de encabezado",
          "PLACEHOLDER": "Texto de encabezado del portal",
          "HELP_TEXT": "El texto de la cabecera del portal se utilizará en el portal de cara al público.",
          "ERROR": "El texto del encabezado del portal es requerido"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal creado correctamente.",
          "ERROR_MESSAGE_FOR_BASIC": "No se pudo crear el portal. Inténtelo de nuevo.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal actualizado correctamente.",
          "ERROR_MESSAGE_FOR_UPDATE": "No se pudo actualizar el portal. Inténtelo de nuevo."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Añadir un nuevo idioma",
        "SUB_TITLE": "Esto añade un nuevo idioma a tu lista de traducciones disponibles.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Idioma",
          "PLACEHOLDER": "Elige un idioma",
          "ERROR": "El idioma es requerido"
        },
        "BUTTONS": {
          "CREATE": "Crear idioma",
          "CANCEL": "Cancelar"
        },
        "API": {
          "SUCCESS_MESSAGE": "Idioma añadido correctamente",
          "ERROR_MESSAGE": "No se puede añadir el idioma. Vuelve a intentarlo."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Idioma por defecto actualizado correctamente",
          "ERROR_MESSAGE": "No se puede actualizar el idioma predeterminado. Vuelve a intentarlo."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Idioma eliminado del portal correctamente",
          "ERROR_MESSAGE": "No se puede eliminar el idioma del portal. Vuelve a intentarlo."
        }
      }
    },
    "TABLE": {
      "404": "No hay artículos que coincidan con su búsqueda 🔍",
      "LOADING_MESSAGE": "Cargando artículos...",
      "NO_ARTICLES": "No hay artículos disponibles",
      "HEADERS": {
        "TITLE": "Título",
        "CATEGORY": "Categoría",
        "READ_COUNT": "Vistas",
        "STATUS": "Estado",
        "LAST_EDITED": "Última edición"
      },
      "COLUMNS": {
        "BY": "por",
        "AUTHOR_NOT_AVAILABLE": "El autor no está disponible"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Cargando artículo...",
      "TITLE_PLACEHOLDER": "Título del artículo va aquí",
      "CONTENT_PLACEHOLDER": "Escriba su artículo aquí",
      "API": {
        "ERROR": "Error al guardar el artículo"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Error al publicar el artículo",
        "SUCCESS": "Artículo publicado correctamente"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Error al archivar el artículo",
        "SUCCESS": "Artículo archivado con éxito"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Error al guardar el borrador del artículo",
        "SUCCESS": "Artículo guardado como borrador correctamente"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Confirmar eliminación",
          "MESSAGE": "¿Está seguro que desea eliminar el artículo?",
          "YES": "Sí, eliminar",
          "NO": "No, mantenerlo"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Artículo eliminado correctamente",
        "ERROR_MESSAGE": "Error al eliminar el artículo"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Por favor, añade el encabezado y el contenido del artículo y después podrás actualizar la configuración"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Buscar artículos"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Crear una categoría",
        "SUB_TITLE": "La categoría se utilizará en el portal público para categorizar artículos.",
        "PORTAL": "Portal",
        "LOCALE": "Idioma",
        "NAME": {
          "LABEL": "Nombre",
          "PLACEHOLDER": "Nombre de categoría",
          "HELP_TEXT": "El nombre de la categoría y el icono se utilizarán en el portal público para categorizar los artículos.",
          "ERROR": "El nombre es requerido"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug de categoría para urls",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug es requerido"
        },
        "DESCRIPTION": {
          "LABEL": "Descripción",
          "PLACEHOLDER": "Dé una breve descripción sobre la categoría.",
          "ERROR": "Descripción requerida"
        },
        "BUTTONS": {
          "CREATE": "Crear categoría",
          "CANCEL": "Cancelar"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categoría creada correctamente",
          "ERROR_MESSAGE": "No se puede crear la categoría"
        }
      },
      "EDIT": {
        "TITLE": "Editar una categoría",
        "SUB_TITLE": "Editar una categoría actualizará la categoría en el portal público.",
        "PORTAL": "Portal",
        "LOCALE": "Idioma",
        "NAME": {
          "LABEL": "Nombre",
          "PLACEHOLDER": "Nombre de categoría",
          "HELP_TEXT": "El nombre de la categoría y el icono se utilizarán en el portal público para categorizar los artículos.",
          "ERROR": "El nombre es requerido"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug de categoría para urls",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug es requerido"
        },
        "DESCRIPTION": {
          "LABEL": "Descripción",
          "PLACEHOLDER": "Dé una breve descripción sobre la categoría.",
          "ERROR": "Descripción requerida"
        },
        "BUTTONS": {
          "CREATE": "Actualizar categoría",
          "CANCEL": "Cancelar"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categoría actualizada correctamente",
          "ERROR_MESSAGE": "No se pudo actualizar la categoría"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Categoría eliminada correctamente",
          "ERROR_MESSAGE": "No se pudo borrar la categoría"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Buscar artículos",
      "PLACEHOLDER": "Buscar artículos",
      "NO_RESULT": "No se encontraron artículos",
      "SEARCHING": "Buscando...",
      "SEARCH_BUTTON": "Buscar",
      "INSERT_ARTICLE": "Insertar enlace",
      "IFRAME_ERROR": "La URL está vacía o no es válida. Imposible mostrar el contenido.",
      "OPEN_ARTICLE_SEARCH": "Insertar artículo del Centro de Ayuda",
      "SUCCESS_ARTICLE_INSERTED": "Artículo insertado correctamente",
      "PREVIEW_LINK": "Previsualizar artículo",
      "CANCEL": "Cerrar",
      "BACK": "Atrás",
      "BACK_RESULTS": "Volver a los resultados"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Centro de ayuda",
      "DESCRIPTION": "Crear portales de autoservicio amigables. Ayuda a tus usuarios a acceder a los artículos y obtener soporte 24/7. Actualiza tu suscripción para activar esta característica.",
      "SELF_HOSTED_DESCRIPTION": "Crear portales de autoservicio amigables. Ayuda a tus usuarios a acceder a los artículos y obtener soporte 24/7. Póngase en contacto con su administrador para habilitar esta característica.",
      "BUTTON": {
        "LEARN_MORE": "Más información",
        "UPGRADE": "Mejorar"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Múltiples portales",
          "DESCRIPTION": "Crear múltiples portales de centro de ayuda para diferentes productos usando la misma cuenta."
        },
        "LOCALES": {
          "TITLE": "Soporte completo de idiomas",
          "DESCRIPTION": "Localiza el portal en tu idioma. Apoyamos todas las localizaciones y permitimos traducciones para cada artículo."
        },
        "SEO": {
          "TITLE": "Diseño amigable con SEO",
          "DESCRIPTION": "Personalice sus meta-etiquetas para mejorar su visibilidad en los motores de búsqueda con nuestras páginas amigables con SEO."
        },
        "API": {
          "TITLE": "Soporte completo de API",
          "DESCRIPTION": "Utilice el portal como un CMS sin cabeceras con frameworks front-end de terceros usando nuestras APIs."
        }
      }
    },
    "LOADING": "Cargando...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} vista | {count} vistas",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publicar",
            "DRAFT": "Borrador",
            "ARCHIVE": "Archivar",
            "DELETE": "Eliminar"
          },
          "STATUS": {
            "DRAFT": "Borrador",
            "PUBLISHED": "Publicado",
            "ARCHIVED": "Archivado"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Sin categoría"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Todos los artículos",
          "MINE": "Mías",
          "DRAFT": "Borrador",
          "PUBLISHED": "Publicado",
          "ARCHIVED": "Archivado"
        },
        "CATEGORY": {
          "ALL": "Todas las categorías"
        },
        "LOCALE": {
          "ALL": "Todos los idiomas"
        },
        "NEW_ARTICLE": "Nuevo artículo"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Escribe un artículo",
          "SUBTITLE": "Escribe un artículo completo, ¡empecemos!",
          "BUTTON_LABEL": "Nuevo artículo"
        },
        "MINE": {
          "TITLE": "Aún no has escrito ningún artículo aquí",
          "SUBTITLE": "Todos los artículos que escribas aparecerán aquí para un acceso rápido."
        },
        "DRAFT": {
          "TITLE": "No hay artículos en borradores",
          "SUBTITLE": "Los artículos en borrador aparecerán aquí"
        },
        "PUBLISHED": {
          "TITLE": "No hay artículos publicados",
          "SUBTITLE": "Los artículos publicados aparecerán aquí"
        },
        "ARCHIVED": {
          "TITLE": "No hay artículos en el archivo",
          "SUBTITLE": "Los artículos archivados no se muestran en el portal; puedes usarlo para marcar páginas obsoletas o desactualizadas"
        },
        "CATEGORY": {
          "TITLE": "No hay artículos en esta categoría",
          "SUBTITLE": "Los artículos de esta categoría aparecerán aquí"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nueva categoría",
        "EDIT_CATEGORY": "Editar categoría",
        "CATEGORIES_COUNT": "{n} categoría | {n} categorías",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Categorías ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} artículos) | {categoryName} ({categoryCount} artículo)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "No se encontraron categorías",
        "SUBTITLE": "Las categorías aparecerán aquí. Puedes añadir una categoría haciendo clic en el botón 'Nueva categoría'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} artículo | {count} artículos",
        "EXPAND": "Mostrar subcategorías",
        "COLLAPSE": "Ocultar subcategorías",
        "MENU": {
          "NEW_ARTICLE": "Nuevo artículo",
          "ADD_SUBCATEGORY": "Añadir subcategoría",
          "EDIT": "Editar",
          "DELETE": "Eliminar"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Categoría creada correctamente",
            "ERROR_MESSAGE": "No se puede crear la categoría"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Categoría actualizada correctamente",
            "ERROR_MESSAGE": "No se pudo actualizar la categoría"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Categoría eliminada correctamente",
            "ERROR_MESSAGE": "No se pudo borrar la categoría"
          },
          "CONFIRM": {
            "TITLE": "Eliminar categoría",
            "DESCRIPTION": "¿Estás seguro de que quieres eliminar esta categoría? Sus artículos quedarán sin categoría.",
            "DESCRIPTION_WITH_CHILDREN": "¿Estás seguro de que quieres eliminar esta categoría? Sus artículos quedarán sin categoría y su {count} subcategoría se moverá al nivel superior. | ¿Estás seguro de que quieres eliminar esta categoría? Sus artículos quedarán sin categoría y sus {count} subcategorías se moverán al nivel superior.",
            "CONFIRM": "Eliminar"
          }
        },
        "HEADER": {
          "CREATE": "Crear categoría",
          "EDIT": "Editar categoría",
          "DESCRIPTION": "Editar una categoría actualizará la categoría en el portal público.",
          "PORTAL": "Portal",
          "LOCALE": "Idioma"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Nombre",
            "PLACEHOLDER": "Nombre de categoría",
            "ERROR": "El nombre es requerido"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug de categoría para urls",
            "ERROR": "Slug es requerido",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Descripción",
            "PLACEHOLDER": "Dé una breve descripción sobre la categoría.",
            "ERROR": "Descripción requerida"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Categoría superior",
            "PLACEHOLDER": "Selecciona una categoría superior",
            "NONE": "Ninguna (nivel superior)"
          }
        },
        "BUTTONS": {
          "CREATE": "Crear",
          "EDIT": "Actualizar",
          "CANCEL": "Cancelar"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "No hay idiomas disponibles | {n} idioma | {n} idiomas",
      "NEW_LOCALE_BUTTON_TEXT": "Nuevo idioma",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} artículo | {count} artículos",
        "CATEGORIES_COUNT": "{count} categoría | {count} categorías",
        "DEFAULT": "Predeterminado",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Establecer como predeterminado",
          "DELETE": "Eliminar"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Añadir un nuevo idioma",
        "DESCRIPTION": "Selecciona el idioma en el que se escribirá este artículo. Se añadirá a tu lista de traducciones y podrás añadir más idiomas más adelante.",
        "COMBOBOX": {
          "PLACEHOLDER": "Seleccionar idioma..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Idioma añadido correctamente",
          "ERROR_MESSAGE": "No se puede añadir el idioma. Vuelve a intentarlo."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Guardando...",
          "SAVED": "Guardado"
        },
        "PREVIEW": "Previsualizar",
        "PUBLISH": "Publicar",
        "DRAFT": "Borrador",
        "ARCHIVE": "Archivar",
        "BACK_TO_ARTICLES": "Volver a los artículos"
      },
      "DRAFT": {
        "PENDING_LABEL": "Cambios sin publicar",
        "PROMOTE": "Publicar cambios",
        "DISCARD": "Descartar cambios",
        "PROMOTE_SUCCESS": "Cambios del borrador publicados en el artículo activo",
        "PROMOTE_ERROR": "No se pudieron publicar los cambios del borrador",
        "DISCARD_SUCCESS": "Cambios del borrador descartados",
        "DISCARD_ERROR": "No se pudieron descartar los cambios del borrador"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Historial de versiones",
        "TITLE": "Historial de versiones",
        "BACK": "Volver al artículo",
        "LOADING": "Cargando versiones...",
        "EMPTY": "Todavía no hay versiones. Las ediciones de este artículo aparecerán aquí.",
        "EMPTY_CONTENT": "Esta versión no tiene contenido.",
        "CURRENT_BADGE": "Actual",
        "RESTORED_BADGE": "Restaurada",
        "AUTOMATED_USER": "Actualización automática",
        "RESTORE": "Restaurar esta versión",
        "RESTORE_DIALOG": {
          "TITLE": "¿Restaurar esta versión?",
          "DESCRIPTION": "El artículo volverá a la redacción de esta versión. No se pierde nada: el texto actual permanece en el historial y un artículo publicado seguirá mostrando la versión activa hasta que publiques el cambio.",
          "CONFIRM": "Restaurar"
        },
        "RESTORE_SUCCESS": "Versión restaurada",
        "RESTORE_ERROR": "No se pudo restaurar esta versión",
        "FETCH_ERROR": "No se pudo cargar el historial de versiones"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Más propiedades",
        "TRANSLATE": "Traducir",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Sin categoría",
        "EDITOR_PLACEHOLDER": "Escribe algo...",
        "HTML_EMBED": {
          "TITLE": "Insertar HTML personalizado",
          "DESCRIPTION": "Pega HTML sin procesar, como un iframe, un embed o un fragmento de widget. Se mostrará tal cual en el artículo publicado.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Insertar"
        },
        "PRIMARY_CATEGORY": "Categoría principal"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Propiedades del artículo",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Meta-descripción",
        "META_DESCRIPTION_PLACEHOLDER": "Añadir meta descripción",
        "META_TITLE": "Título Meta",
        "META_TITLE_PLACEHOLDER": "Añadir meta título",
        "META_TAGS": "Meta etiquetas",
        "META_TAGS_PLACEHOLDER": "Añadir meta etiquetas",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Variantes de idioma",
        "LANGUAGE_MUTATIONS_EMPTY": "Aún no hay artículos vinculados",
        "ADD_MUTATION": "Añadir",
        "REMOVE_MUTATION": "Eliminar"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Vincular variantes de idioma",
        "SEARCH_PLACEHOLDER": "Buscar artículos por título",
        "EMPTY": "No hay artículos coincidentes",
        "CANCEL": "Cancelar",
        "ADD_SELECTED": "Añadir seleccionados",
        "SUCCESS": "Variantes actualizadas",
        "ERROR": "Error al actualizar las variantes"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Traducir artículo",
        "DESCRIPTION": "Selecciona los idiomas a los que quieres traducir este artículo. Los idiomas que ya estén traducidos se volverán a traducir en un borrador para su revisión.",
        "EMPTY": "No hay otros idiomas disponibles",
        "CONNECTED_BADGE": "Traducido",
        "CANCEL": "Cancelar",
        "TRANSLATE": "Traducir",
        "SUCCESS": "La traducción comenzará en breve. Los artículos traducidos aparecerán pronto como variantes de idioma.",
        "ERROR": "Error al iniciar la traducción"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "Error al guardar el artículo"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Nuevo portal",
      "PORTALS": "Portales",
      "CREATE_PORTAL": "Crea y gestiona varios portales",
      "ARTICLES": "artículos",
      "DOMAIN": "dominio",
      "PORTAL_NAME": "Nombre del portal"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Crear nuevo portal",
      "DESCRIPTION": "Ponle un nombre a tu portal y crea un slug de URL fácil de usar. Podrás modificar ambos más adelante en los ajustes.",
      "CONFIRM_BUTTON_LABEL": "Crear",
      "NAME": {
        "LABEL": "Nombre",
        "PLACEHOLDER": "Guía del usuario",
        "MESSAGE": "Elige un nombre para tu portal.",
        "ERROR": "El nombre es requerido"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "Slug es requerido",
        "FORMAT_ERROR": "Usa solo letras, números y guiones, por ejemplo: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "¡No se pudo subir la imagen! Intente nuevamente",
          "IMAGE_UPLOAD_SUCCESS": "Imagen añadida correctamente. Haz clic en guardar cambios para guardar el logo",
          "IMAGE_DELETE_SUCCESS": "Logo eliminado correctamente",
          "IMAGE_DELETE_ERROR": "No se pudo eliminar el logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "El tamaño de la imagen debe ser menor que {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Nombre",
          "PLACEHOLDER": "Nombre del portal",
          "ERROR": "El nombre es requerido"
        },
        "HEADER_TEXT": {
          "LABEL": "Texto de encabezado",
          "PLACEHOLDER": "Texto de encabezado del portal"
        },
        "PAGE_TITLE": {
          "LABEL": "Título de página",
          "PLACEHOLDER": "Título de página del portal"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Enlace de la página de inicio",
          "PLACEHOLDER": "Enlace de página de inicio del portal",
          "ERROR": "URL no válida. El enlace de la página de inicio debe comenzar con 'http://' o 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug del portal"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Widget de chat en vivo",
          "PLACEHOLDER": "Selecciona un widget de chat en vivo",
          "HELP_TEXT": "Selecciona un widget de chat en vivo que aparecerá en tu centro de ayuda"
        },
        "LINK_TARGET": {
          "LABEL": "Destino del enlace",
          "HELP_TEXT": "Elige si los enlaces dentro de los artículos se abren en la ventana actual o en una nueva.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Ventana actual",
            "NEW_WINDOW": "Nueva ventana"
          }
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Acceso público",
          "HELP_TEXT": "Hacer el portal accesible para todos con el enlace.",
          "OPTIONS": {
            "PUBLIC": "Sí",
            "PRIVATE": "No"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Tamaño de imagen predeterminado",
          "HELP_TEXT": "Tamaño aplicado a cada imagen que insertas en un artículo. Elige Original para insertar las imágenes en su propio tamaño y elegir un tamaño por imagen en su lugar."
        },
        "BRAND_COLOR": {
          "LABEL": "Color de marca"
        },
        "CUSTOM_HTML": {
          "LABEL": "HTML personalizado",
          "PLACEHOLDER": "<!-- Pega aquí tu fragmento de analíticas o seguimiento -->",
          "HELP_TEXT": "Se inserta al principio de la etiqueta <body> en cada página del centro de ayuda. Úsalo para Google Analytics, Google Tag Manager o cualquier otro fragmento de seguimiento. El código se renderiza exactamente como se introdujo y no se valida."
        },
        "SAVE_CHANGES": "Guardar cambios"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Dominio personalizado",
          "LABEL": "Dominio personalizado:",
          "DESCRIPTION": "Puedes alojar tu portal en un dominio personalizado. Por ejemplo, si tu sitio web es yourdomain.com y quieres que tu portal esté disponible en docs.yourdomain.com, simplemente introduce eso en este campo.",
          "PLACEHOLDER": "Dominio personalizado del portal",
          "EDIT_BUTTON": "Editar dominio personalizado",
          "ADD_BUTTON": "Añadir dominio personalizado",
          "DIALOG": {
            "ADD_HEADER": "Añadir dominio personalizado",
            "EDIT_HEADER": "Editar dominio personalizado",
            "ADD_CONFIRM_BUTTON_LABEL": "Añadir dominio",
            "EDIT_CONFIRM_BUTTON_LABEL": "Actualizar dominio",
            "LABEL": "Dominio personalizado",
            "PLACEHOLDER": "Dominio personalizado del portal",
            "ERROR": "El dominio personalizado es obligatorio"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Configuración DNS",
            "DESCRIPTION": "Inicia sesión en la cuenta que tienes con tu proveedor de DNS y añade el siguiente registro CNAME para tu subdominio.",
            "HELP_TEXT": "Una vez hecho esto, puedes ponerte en contacto con nuestro soporte para solicitar el certificado SSL generado automáticamente.",
            "CONFIRM_BUTTON_LABEL": "¡Entendido!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Eliminar {portalName}",
          "HEADER": "Eliminar portal",
          "DESCRIPTION": "Eliminar este portal permanentemente. Esta acción es irreversible",
          "DIALOG": {
            "HEADER": "¿Seguro que quieres eliminar {portalName}?",
            "DESCRIPTION": "Esta es una acción permanente que no se puede deshacer.",
            "CONFIRM_BUTTON_LABEL": "Eliminar"
          }
        },
        "EDIT_CONFIGURATION": "Editar configuración"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal creado correctamente",
          "ERROR_MESSAGE": "No se pudo crear el portal"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal actualizado correctamente",
          "ERROR_MESSAGE": "No se pudo actualizar el portal"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Adjuntos",
      "DRAFT_BADGE": "Borrador",
      "ADD_BUTTON": "Añadir archivo",
      "DROP_HERE": "Arrastra y suelta archivos aquí",
      "COPY_LINK": "Copiar enlace",
      "LINK_COPIED": "Enlace copiado al portapapeles",
      "COPY_FAILED": "No se pudo copiar el enlace",
      "DELETE": "Eliminar",
      "CANCEL": "Cancelar",
      "QUEUED": "En cola",
      "UPLOADING": "Subiendo",
      "UPLOAD_FAILED": "No se pudo subir el archivo",
      "FILE_TOO_LARGE": "El archivo supera el límite de tamaño de 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Diccionario de traducción",
        "DESCRIPTION": "Los términos definidos aquí se añaden al prompt de traducción de la IA para que siempre se traduzcan de la misma manera. El término clave está escrito en {locale}."
      },
      "NEW_TERM": "Nuevo término",
      "EMPTY_STATE": {
        "TITLE": "Aún no hay términos en el diccionario",
        "SUBTITLE": "Añade un término y su traducción para cada idioma. Cuando se traduce un artículo, estos términos se aplican para que la terminología de tu producto se mantenga coherente."
      },
      "LIST": {
        "TERM": "Término",
        "TRANSLATIONS": "Traducciones",
        "ACTIONS": "Acciones"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Añadir término",
          "EDIT": "Editar término",
          "DESCRIPTION": "El siguiente término se aplica durante la traducción con IA de los artículos de tu centro de ayuda.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Idioma principal"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Término ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "El término es requerido"
          },
          "DESCRIPTION": {
            "LABEL": "Contexto / notas (opcional)",
            "PLACEHOLDER": "Cuándo y cómo se usa este término, para ayudar al traductor a desambiguar."
          },
          "TRANSLATIONS": "Traducciones",
          "TRANSLATION_PLACEHOLDER": "Déjalo vacío para que la IA traduzca libremente",
          "AUTO_TRANSLATE": {
            "BUTTON": "Autotraducir todo",
            "CONFIRM": "¿Traducir a {count} idiomas con IA?",
            "CONFIRM_BUTTON": "Traducir",
            "CANCEL": "Cancelar",
            "SUCCESS": "Traducciones generadas — revisa y guarda",
            "ERROR": "No se pudo autotraducir, inténtalo de nuevo"
          }
        },
        "BUTTONS": {
          "CREATE": "Añadir término",
          "EDIT": "Guardar",
          "CANCEL": "Cancelar"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Término añadido correctamente",
            "ERROR_MESSAGE": "No se pudo añadir el término, inténtalo de nuevo"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Término actualizado correctamente",
            "ERROR_MESSAGE": "No se pudo actualizar el término, inténtalo de nuevo"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Eliminar término",
          "DESCRIPTION": "¿Estás seguro de que quieres eliminar este término? Dejará de aplicarse durante la traducción.",
          "CONFIRM": "Eliminar"
        },
        "API": {
          "SUCCESS_MESSAGE": "Término eliminado correctamente",
          "ERROR_MESSAGE": "No se pudo eliminar el término, inténtalo de nuevo"
        }
      }
    }
  }
}
